module.exports = {
  id: 13,
  name: 'Big Arm Swings',
  categories: ['cardio', 'arms', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Coordination',
  points: 10,
  instructions:
    'Big arm swings time! Stand with your feet apart, swing your arms in big circles forward and backward, and add a squat when you swing down!',
  timedInstructions: [
    {
      time: 0,
      text: "You're a robot doing the robot dance! 3, 2, 1, ACTIVATE!",
    },
    {
      time: 3,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 5,
      text: 'Power down and squat!',
    },
    {
      time: 7,
      text: 'Reboot and swing forward!',
    },
    {
      time: 9,
      text: 'Power down and squat!',
    },
    {
      time: 11,
      text: 'Keep going, robot!',
    },
    {
      time: 13,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 15,
      text: 'Power down and squat!',
    },
    {
      time: 17,
      text: 'Swing forward, robot dance!',
    },
    {
      time: 19,
      text: 'Power down and squat!',
    },
    {
      time: 21,
      text: "You're an awesome robot!",
    },
    {
      time: 23,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 25,
      text: 'Power down and squat!',
    },
    {
      time: 27,
      text: 'Great job, superstar robot! Take a quick break',
    },
    {
      time: 30,
      text: 'Breathe in and out',
    },
    {
      time: 33,
      text: 'Ready for round two, robot!',
    },
    {
      time: 36,
      text: '3, 2, 1, REACTIVATE!',
    },
    {
      time: 39,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 41,
      text: 'Power down and squat!',
    },
    {
      time: 43,
      text: 'Reboot and swing forward!',
    },
    {
      time: 45,
      text: 'Power down and squat!',
    },
    {
      time: 47,
      text: 'Keep going, robot!',
    },
    {
      time: 49,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 51,
      text: 'Power down and squat!',
    },
    {
      time: 53,
      text: 'Swing forward, robot dance!',
    },
    {
      time: 55,
      text: 'Power down and squat!',
    },
    {
      time: 57,
      text: "You're getting stronger, robot!",
    },
    {
      time: 59,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 61,
      text: 'Power down and squat!',
    },
    {
      time: 63,
      text: 'Amazing job, champion robot! Take another break',
    },
    {
      time: 66,
      text: 'Breathe in and out',
    },
    {
      time: 69,
      text: 'Ready for round three, robot!',
    },
    {
      time: 72,
      text: '3, 2, 1, REACTIVATE!',
    },
    {
      time: 75,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 77,
      text: 'Power down and squat!',
    },
    {
      time: 79,
      text: 'Reboot and swing forward!',
    },
    {
      time: 81,
      text: 'Power down and squat!',
    },
    {
      time: 83,
      text: 'Keep going, robot!',
    },
    {
      time: 85,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 87,
      text: 'Power down and squat!',
    },
    {
      time: 89,
      text: 'Swing forward, robot dance!',
    },
    {
      time: 91,
      text: 'Power down and squat!',
    },
    {
      time: 93,
      text: 'Keep going, champion robot!',
    },
    {
      time: 95,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 97,
      text: 'Power down and squat!',
    },
    {
      time: 99,
      text: 'Great job, hero robot! Take a final break',
    },
    {
      time: 102,
      text: 'Breathe in and out',
    },
    {
      time: 105,
      text: 'Ready for the final round, robot!',
    },
    {
      time: 108,
      text: '3, 2, 1, FINAL ACTIVATION!',
    },
    {
      time: 111,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 113,
      text: 'Power down and squat!',
    },
    {
      time: 115,
      text: 'Reboot and swing forward!',
    },
    {
      time: 117,
      text: 'Power down and squat!',
    },
    {
      time: 119,
      text: 'Keep going, robot!',
    },
    {
      time: 121,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 123,
      text: 'Power down and squat!',
    },
    {
      time: 125,
      text: 'Swing forward, robot dance!',
    },
    {
      time: 127,
      text: 'Power down and squat!',
    },
    {
      time: 129,
      text: 'Final push, hero robot!',
    },
    {
      time: 131,
      text: 'Mechanical arm swing forward!',
    },
    {
      time: 133,
      text: 'Power down and squat!',
    },
    {
      time: 135,
      text: 'You did it, champion robot!',
    },
    {
      time: 137,
      text: "Awesome job, you're a robot master!",
    },
  ],
};
